/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface GenericOrderConfirmAttributesContactAccount
 */
export interface GenericOrderConfirmAttributesContactAccount {
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributesContactAccount
     */
    accountType?: GenericOrderConfirmAttributesContactAccountAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributesContactAccount
     */
    address?: string;
    /**
     * 
     * @type {number}
     * @memberof GenericOrderConfirmAttributesContactAccount
     */
    city?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributesContactAccount
     */
    companyCode?: string;
    /**
     * 
     * @type {number}
     * @memberof GenericOrderConfirmAttributesContactAccount
     */
    country?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributesContactAccount
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributesContactAccount
     */
    iataNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributesContactAccount
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributesContactAccount
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributesContactAccount
     */
    postalCode?: string;
    /**
     * 
     * @type {number}
     * @memberof GenericOrderConfirmAttributesContactAccount
     */
    region?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributesContactAccount
     */
    taxId?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum GenericOrderConfirmAttributesContactAccountAccountTypeEnum {
    Agency = 'agency',
    Company = 'company',
    Individual = 'individual'
}

